/*
 * @Author: 刘云皓 857862796@qq.com
 * @Date: 2024-05-15 10:32:45
 * @LastEditors: 刘云皓 857862796@qq.com
 * @LastEditTime: 2024-05-29 17:05:34
 * @FilePath: \Cloud-API-Demo-Web\src\api\http\config.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const CURRENT_CONFIG = {

  // license
  appId: '138882', // You need to go to the development website to apply.
  appKey: '0632fe74a67c407da114899eb8be146', // You need to go to the development website to apply.
  appLicense: 'pTEN9rRuXIxN0yQGOfLzEiZFnIreiwdBGjSyKc3TLwbYVzTbVowXW4iHwcIRQHAjwLyvaQGSicaK9Zxz7veUz4TiQW6MwB/JkWa0BiBbGDX7xZGzV7Qjy/krRmO3B+h5lAONzQf4EzhOwH77KrNOzEcLwthdjOe3S7mkGOZ0pic=', // You need to go to the development website to apply.

  // http
  // baseURL: 'http://43.139.118.6:6789/', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  baseURL: 'https://dj.aiag.clife.cn/', // This url must end with "/". Example: 'http://192.168.1.1:6789/'

  websocketURL: 'wss://dj.aiag.clife.cn/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws'

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'Please enter the rtmp access address.', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora //直播业务
  agoraAPPID: 'da5a6821c971468c98296d71365f1ae6',
  agoraToken: '007eJxTYIi3ZP1aseOtzyfNzxVP12gKqT3Oe3l2ivM19jl8lu/jFhsqMKQkmiaaWRgZJluaG5qYWSRbWhhZmqWYGxqbmaYZJqaa7XkfltYQyMhwo9WAgREKQXxWhuSc/NIUBgYAnr0gbw==',
  agoraChannel: 'cloud',

  // map
  // You can apply on the AMap website.
  amapKey: 'ff4e533d1e35ad3165424d06e06decb5',

}
